"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _IconButton = require("./IconButton.styles");
var _theme = require("../utils/theme");
var _Icon = require("../Icon");
var _excluded = ["children", "theme", "size", "color", "containerColor", "format", "onClick", "dense", "disabled", "colored", "icon", "padding"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var IconButton = function IconButton(_ref) {
  var children = _ref.children,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '25' : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#333333' : _ref$color,
    containerColor = _ref.containerColor,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? 'square' : _ref$format,
    onClick = _ref.onClick,
    _ref$dense = _ref.dense,
    dense = _ref$dense === void 0 ? false : _ref$dense,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$colored = _ref.colored,
    colored = _ref$colored === void 0 ? false : _ref$colored,
    icon = _ref.icon,
    padding = _ref.padding,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_IconButton.ButtonContainer, (0, _extends2["default"])({
    disabled: disabled,
    colored: colored,
    containerColor: containerColor,
    color: color,
    size: size,
    icon: icon,
    isSelected: selected,
    format: format,
    onClick: disabled ? null : onClick,
    dense: dense,
    onMouseDown: function onMouseDown() {
      return disabled ? null : setSelected(true);
    },
    onMouseUp: function onMouseUp() {
      return disabled ? null : setSelected(false);
    },
    padding: padding
  }, props), /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    color: disabled ? theme.color.gray : color,
    size: size,
    icon: icon
  }), children));
};
var _default = exports["default"] = IconButton;